import React, { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import ComingSoon from "@/pages/ComingSoon";

/**
 * Root app - wires Lenis momentum scrolling to the whole document.
 */
const useLenis = () => {
    const rafRef = useRef();
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.4,
        });

        const raf = (time) => {
            lenis.raf(time);
            rafRef.current = requestAnimationFrame(raf);
        };
        rafRef.current = requestAnimationFrame(raf);

        // Intercept in-page anchor clicks for smooth navigation.
        const onAnchor = (e) => {
            const a = e.target.closest("a[href^='#']");
            if (!a) return;
            const id = a.getAttribute("href");
            if (!id || id === "#") return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: 0, duration: 1.4 });
            }
        };
        document.addEventListener("click", onAnchor);

        return () => {
            cancelAnimationFrame(rafRef.current);
            lenis.destroy();
            document.removeEventListener("click", onAnchor);
        };
    }, []);
};

function App() {
    useLenis();
    return (
        <div className="App font-sans-body text-ink-900" data-testid="app-root">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<ComingSoon />} />
                    <Route path="*" element={<ComingSoon />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
